import React, { useEffect } from "react";
import { Button } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import PWAInstallerPrompt from "react-pwa-installer-prompt";
// import { useAddToHomescreenPrompt } from "./installButtonConfig.tsx";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

const InstallButton = () => {
  const lang_choiced = useSelector((state) => state.lang_change);

  // const [prompt, promptToInstall] = useAddToHomescreenPrompt();
  // const dispatch = useDispatch();
  //   notify = () => toast("Wow so easy !");

  // Notification.requestPermission(function (status) {
  //   console.log("Notification permission status:", status);
  //   if (Notification.permission == "granted") {
  //     navigator.serviceWorker.getRegistration().then(function (reg) {
  //       reg.showNotification("Hello world!");
  //     });
  //   }
  // });
  let installPromptEvent;

  // installPromptEvent.prompt();
  useEffect(() => {
    window.addEventListener("beforeinstallprompt", (e) => {
      Notification.requestPermission();
      // console.log(e, "is installprompt");
      e.preventDefault();
      // console.log("before install prompt event");
      installPromptEvent = e;
      // Notification.requestPermission(function (status) {
      //   console.log("Notification permission status:", status);
      //   if (Notification.permission == "granted") {
      //     navigator.serviceWorker.getRegistration().then(function (reg) {
      //       // reg.showNotification("Hello world!");
      //     });
      //   }
      // });
      // installPromptEvent.prompt();
    });
  });
  // document.getElementById('#installButton').addEventListener('click' , (e) => {
  //     e.preventDefault();
  //     console.log(installPromptEvent);
  //     if(installPromptEvent) {
  //         installPromptEvent.prompt();

  //         installPromptEvent.userChoice
  //             .then((choiceResult) => {
  //                 if(choiceResult.outcome === 'accepted') {
  //                     console.log('User Accepted');
  //                 } else {
  //                     console.log('User dismissed');
  //                 }

  //                 installPromptEvent = null;
  //             })
  //     }
  // })

  return (
    <div>
      <PWAInstallerPrompt
        render={({ onClick }) => (
          <Button
            id="installButton"
            type="primary"
            style={{ fontSize: "17px" }}
            // onClick={(e) => {

            //   // e.preventDefault();

            //   console.log(installPromptEvent);
            //   if (installPromptEvent) {
            //     console.log(installPromptEvent , "is prompt")
            //     installPromptEvent.prompt();

            //     installPromptEvent.userChoice.then((choiceResult) => {
            //       if (choiceResult.outcome === "accepted") {
            //         console.log("User Accepted");
            //       } else {
            //         console.log("User dismissed");
            //       }

            //       installPromptEvent = null;
            //     });
            //   }
            // }}
            // onClick={prompt?promptToInstall:""}
            onClick={onClick}
          >
            {lang_choiced.aside_menu.btnInstall}&nbsp;
            <DownloadOutlined />
          </Button>
        )}
        callback={(data) => {
          // console.log(data);
        }}
      />
    </div>
  );
};
export default InstallButton;
